import React from 'react';

import { isEqual } from 'lodash';

import { siteIds } from '../../../constants';
import { siteId } from '../../../sites';

import ViinimaaAdditionalNavigation from './viinimaa';

function AdditionalNavigation(props) {
  if (isEqual(siteId, siteIds.Viinimaa)) {
    return <ViinimaaAdditionalNavigation {...props} />;
  }
  if (isEqual(siteId, siteIds.Folkofolk)) {
    return <ViinimaaAdditionalNavigation {...props} />;
  }

  return null;
}

export default AdditionalNavigation;
